import { JetView } from 'webix-jet'; // Importing JetView for creating a view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix

/**
 * FilterContigenciaView class extends JetView to create a filter view.
 */
export default class FilterContigenciaView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for description
                            name: 'Description',
                            label: "<span class='icon-file-text1'></span>" + _('Descripción'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Descripción'), // Placeholder text
                            invalidMessage: _('Descripción is required'), // Validation message
                        },
                        { id: 'grav2', gravity: 2 }, // Gravity for layout
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Adding left section to upper section
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Button to clear form
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear the form
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter data
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('contigencia:filter', [
                                    filterdata, // Trigger filter event with data
                                ]);
                            },
                        },
                    ],
                },
            ],
        };

        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to clear second form
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear(); // Clear the second form
                    },
                },
                {
                    view: 'button', // Button to consult/filter data in second form
                    value: _('Consultar'),
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get values from second form
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if condition met
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition met
                            }
                        }
                        this.app.callEvent('contigencia:filter', [filterdata]); // Trigger filter event
                        $$('filterPopup').hide(); // Hide the filter popup
                    },
                },
            ],
        };

        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for accordion
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Adding upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Adding upper section
            },
        };

        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // Second form for filters
                type: 'clean',
                rows: [accordion_section3, buttons2], // Adding accordion and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });

        return {
            view: 'form', // Main form for the view
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder if not
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }
}

// FILE DOCUMENTED
